import React from "react";
import { Box, Container, Typography } from "@mui/material";

const PageHeader = ({ title, subtitle }) => {
  return (
    <Box
      sx={{
        background: "linear-gradient(90deg, #0B0F19, #1A2E55)",
        color: "#FFFFFF",
        paddingY: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: "#FFFFFF",
            fontSize: { xs: "2.5rem", md: "3.5rem" },
            marginBottom: "16px",
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#D1D5DB",
            fontSize: { xs: "1rem", md: "1.2rem" },
            maxWidth: "800px",
            margin: "0 auto",
            lineHeight: 1.6,
          }}
        >
          {subtitle}
        </Typography>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "60%",
            height: "3px",
            background: "linear-gradient(90deg, #A9C9EA, #0056b3)",
            borderRadius: "2px",
          }}
        />
      </Container>
    </Box>
  );
};

export default PageHeader;
